import { useIntl } from 'react-intl';
import { InGameLayout } from '../layout/in-game-layout';
import { Menu } from '../components/menu';
import MainContent from '../layout/main-content';
import Portfolio from '../components/portfolio';

const PortfolioPage = () => {
  const { formatMessage } = useIntl();
  return (
    <InGameLayout side={<Menu />}>
      <MainContent title={formatMessage({ id: 'portfolio.title' })} hideFrame>
        <Portfolio />
      </MainContent>
    </InGameLayout>
  );
};

export default PortfolioPage;
